import { createPortal } from 'react-dom';
import './Popup.css';

const PopUp = ({ isOpen, onClose, msg, desc }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="pop-body" role="dialog" aria-modal="true" aria-labelledby="popup-title">
      <div className="pop-main">
        <div className="pop-icon-wrap">
          <div className="pop-icon-o">
            <svg
              className="pop-icon-i"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
        <h2 id="popup-title" className="pop-heading">{msg}</h2>
        <p className="pop-text">{desc}</p>
        <button type="button" className="button" onClick={onClose}>
          Back
        </button>
      </div>
    </div>,
    document.body
  );
};

export default PopUp;
